import React from 'react';
import { useFormEmbedScript } from '../hooks/useFormEmbedScript';
const FORM_ID = 'JYw51eITepBsqljYoBQr';
export function NewsletterSignup() {
  useFormEmbedScript();
  return <section id="newsletter" className="w-full bg-charcoal-900 py-20 px-6 md:px-12" aria-labelledby="newsletter-heading" data-id="element-246" data-mp="18tixl50zh4hg">
      <div className="max-w-3xl mx-auto text-center" data-id="element-247" data-mp="1drawij01pqv5">
        <h2 id="newsletter-heading" className="text-3xl md:text-4xl font-bold text-offwhite-50 mb-4" data-id="element-248" data-mp="yvl70avnivlo">
          Not ready to book yet?
        </h2>
        <p className="text-lg text-offwhite-200 leading-relaxed mb-8" data-id="element-249" data-mp="13sbp13r0o19q">
          Get practical tips each month on wellness, performance, and staying
          active.
        </p>

        <div className="w-full max-w-[560px] mx-auto bg-charcoal-900" data-id="element-250" data-mp="utzz73xz57ic">
          <iframe src={`https://api.leadconnectorhq.com/widget/form/${FORM_ID}`} style={{
          width: '100%',
          height: 260,
          border: 'none',
          background: '#1A1A1A'
        }} id={`inline-${FORM_ID}`} data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="CA - Newsletter Sign Up Form" data-height="260" data-layout-iframe-id={`inline-${FORM_ID}`} data-form-id={FORM_ID} data-cookie-consent="true" data-cookie-consent-provider="auto" title="McLean PT Newsletter Sign Up" data-id="element-251" data-mp="2k9pmn9nkzby3" />
        </div>
      </div>
    </section>;
}